//CRN_20260519 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { AuthenticationService } from '../../auth.service';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgTab } from 'src/app/core/interfaces/datagrid/dg-tab';
import { DropdownData } from 'src/app/core/interfaces/general/drop-down-data';
import { EncryptionService } from './encryption-service';
import { ExceptionsService } from './exceptions-service';
import { HttpClientService } from './http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({
  providedIn: 'root'
})

export class GridViewService {

  private _apiMethodOverrideGet: Observable<any> | undefined;
  private _apiPathDelete       : string          | undefined="";
  private _apiPathGet          : string          | undefined="";
  private _apiPathPost         : string          | undefined="";
  private _apiPathPut          : string          | undefined="";
  private _dgColumns           : Array<DgColumn> | undefined=[];
  private _dgTabs              : Array<DgTab>    | undefined=[];
  private _dropdownDataArray   : Array<DropdownData>=[];
  // private _encryptDelete       : boolean         | undefined=false;
  private _encryptDeleteSS     : boolean         | undefined=false;
  private _encryptPost         : boolean         | undefined=false;
  private _encryptPut          : boolean         | undefined=false;
  //private fireEventSubject     : Subject<Data | undefined> = new Subject<Data | undefined>();

  //public fireEvent$            : Observable<Data | undefined> = this.fireEventSubject.asObservable();

  get apiPathDelete    () { return this._apiPathDelete    ; }
  get apiPathGet       () { return this._apiPathGet       ; }
  get apiPathPost      () { return this._apiPathPost      ; }
  get apiPathPut       () { return this._apiPathPut       ; }
  get dgColumns        () { return this._dgColumns        ; }
  get dgTabs           () { return this._dgTabs           ; }
  get dropdownDataArray() { return this._dropdownDataArray; }
  // get encryptDelete    () { return this._encryptDelete    ; }
  get encryptDeleteSS  () { return this._encryptDeleteSS  ; }
  get encryptPost      () { return this._encryptPost      ; }
  get encryptPut       () { return this._encryptPut       ; }
  
  set apiMethodOverrideGet(apiMethodOverrideGet: Observable<any>     | undefined ) { this._apiMethodOverrideGet=apiMethodOverrideGet; }
  set apiPathDelete       (apiPathDelete       : string              | undefined ) { this._apiPathDelete       =apiPathDelete       ; }
  set apiPathGet          (apiPathGet          : string              | undefined ) { this._apiPathGet          =apiPathGet          ; }
  set apiPathPost         (apiPathPost         : string              | undefined ) { this._apiPathPost         =apiPathPost         ; }
  set apiPathPut          (apiPathPut          : string              | undefined ) { this._apiPathPut          =apiPathPut          ; }
  set dgColumns           (dgColumns           : Array<DgColumn>     | undefined ) { this._dgColumns           =dgColumns           ; }
  set dgTabs              (dgTabs              : Array<DgTab>        | undefined ) { this._dgTabs              =dgTabs              ; }
  set dropdownDataArray   (dropdownDataArray   : Array<DropdownData>             ) { this._dropdownDataArray   =dropdownDataArray   ; }
  // set encryptDelete       (encryptDelete       : boolean             | undefined ) { this._encryptDelete       =encryptDelete       ; }
  set encryptDeleteSS     (encryptDeleteSS     : boolean             | undefined ) { this._encryptDeleteSS     =encryptDeleteSS     ; }
  set encryptPost         (encryptPost         : boolean             | undefined ) { this._encryptPost         =encryptPost         ; }
  set encryptPut          (encryptPut          : boolean             | undefined ) { this._encryptPut          =encryptPut          ; }

  constructor(
    private authenticationService: AuthenticationService,
    private encryptionService    : EncryptionService,
    private exceptionsService    : ExceptionsService,
    private httpClientService    : HttpClientService
  ) {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public validateApiPaths(): void {
    try {
      if (!this._apiPathDelete)
        throw new Error('GridViewService.validateApiPaths() - apiPathDelete is NULL or EMPTY');

      if (!this._apiPathGet)
        throw new Error('GridViewService.validateApiPaths() - apiPathGet is NULL or EMPTY');

      if (!this._apiPathPost)
        throw new Error('GridViewService.validateApiPaths() - apiPathPost is NULL or EMPTY');

      if (!this._apiPathPut)
        throw new Error('GridViewService.validateApiPaths() - apiPathPut is NULL or EMPTY');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public getClientSideProcessingModels(): Observable<any[]>{
    try {
      if (!this._apiPathGet)
        return of();
  
      return this._apiMethodOverrideGet==undefined ? this.httpClientService.get(this._apiPathGet) : this._apiMethodOverrideGet;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  populateDropdownDataArray(emitWhenComplete?: boolean) {
    try {
      this.dropdownDataArray=[];

      // if (emitWhenComplete && (this.dgColumns==undefined || this.dgColumns.length<=0)) {
      //   this.fireEventSubject.next(undefined);
      // }

      if (this.dgColumns) {
        for(let column of this.dgColumns) {
          if (column.dataSourceForAForm) {
            column.dataSourceForAForm
            .pipe(
              catchError((error) => {
                return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
              })
            )
            .subscribe({
              next: data => {
                let dropdownData: DropdownData;
                dropdownData={
                  dbFieldName: column.dataField,
                  objectArray: (data as IdAndDescriptionDTO[])
                };
                
                this.dropdownDataArray.push(dropdownData);

                // if (emitWhenComplete && column.lastDataSource) {
                //   this.fireEventSubject.next(data);
                // }
               },
              error: error => {
                this.exceptionsService.handleException(new Error(error));
              }
            });
          }
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  getDropdownDataObjectArray(fieldName: string) {
    try {
      let dropdownData: DropdownData | undefined;
      dropdownData = this.dropdownDataArray.find(x => x.dbFieldName==fieldName);

      if (dropdownData)
        return dropdownData.objectArray;
      else
        return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return (undefined);
    }
  }
  
  public save(model: any): Observable<any> {
    try {
      // JSON.stringify(model);

      if ((model.id && !this._apiPathPut) || !this._apiPathPost)
        return of();

      if (model["enteredByName"] != undefined && model["enteredBy"]==undefined) {
        model["enteredBy"]=this.authenticationService.currentUserObject().userId;
      }
      
      if (model.id) {
        if (this._encryptPut)
          return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(model))
                 .pipe(
                   switchMap((encResult: StringResultDTO) => {
                     const objectEnc=encResult.result;
                     
                     return this.httpClientService.put(this._apiPathPut + "?id=" + model.id + "&objectEnc=" + objectEnc, undefined, {});
                   })
                 );


        return this.httpClientService.put(this._apiPathPut + "/", model.id, model);
      }
      
      if (this._encryptPost)
        return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(model))
               .pipe(
                 switchMap((encResult: StringResultDTO) => {
                   const objectEnc=encResult.result;
                   
                   return this.httpClientService.post(this._apiPathPost + "?objectEnc=" + objectEnc, {});
                 })
               );

      return this.httpClientService.post(this._apiPathPost, model);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public delete(id: number) {
    try {
      if (!this._apiPathDelete)
        return of();
      
      // if (this._encryptDelete)
      //   return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id)
      //          .pipe(
      //            switchMap((encResult: StringResultDTO) => {
      //              const idEnc=encResult.result;
                   
      //              return this.httpClientService.delete(this._apiPathDelete + "?idEnc=" + idEnc);
      //            })
      //          );
      
      if (this._encryptDeleteSS)
        return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
               .pipe(
                 switchMap((encResult: StringResultDTO) => {
                   const idEncSS=encResult.result;
                   
                   return this.httpClientService.delete(this._apiPathDelete + "?idEncSS=" + idEncSS);
                 })
               );


      return this.httpClientService.delete(this._apiPathDelete + "/", id);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
